import MenuItem from "./MenuItem";
import List from "json/menulist.json";
import { useCallback, useEffect, useRef, useState } from "react";
import useClickOutside from "../../../utils/useClickOutside";
import { useUser } from "store/models";
import Icon from "components/Icon";

function openMenu(){
  let masterpage = document.getElementById("masterpage");
  if(masterpage){
    if(masterpage.classList.contains("menu-open")){
      masterpage.classList.remove("menu-open");
    } else {
      masterpage.classList.add("menu-open");
    }
    let elements = masterpage.getElementsByClassName("open-menu-item");
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      element.classList.remove("open-menu-item");
    } 
  }
}
function getElement(element:Element,name:string){
  let list = element.getElementsByClassName(name);
  if(list.length > 0){
    return list[0];
  }
  return null;
}
function isOverflown(element:Element) {
  let r = {top:false, bottom:false};
  const rect = element.getBoundingClientRect();
  const children = element.getElementsByClassName("menu-item");
  if(children){
    for (let i = 0; i < children.length; i++) {
      const rectC = children[i].getBoundingClientRect();
      if(rect.top > rectC.top){
        r.top = true;
      } else if (rect.top + rect.height < rectC.top + rectC.height){
        r.bottom = true;
      }
    }
  }
  return r;
}
function activate_scroll(scroll:Element){
  if(scroll.classList.contains("scroll-disabled")){
    scroll.classList.remove("scroll-disabled")
  }
}
function deactivate_scroll(scroll:Element){
  if(!scroll.classList.contains("scroll-disabled")){
    scroll.classList.add("scroll-disabled")
  }
}
function verify(){
  const menu_list = document.getElementById("masterpage-menu-list-area");
  if(menu_list){
    const ul = getElement(menu_list,"list-item");
    const scroll_up = getElement(menu_list,"up-scroll");
    const scroll_down = getElement(menu_list,"down-scroll");
    if(ul && scroll_up && scroll_down){
      let scroll = isOverflown(ul);
      if(scroll.top) activate_scroll(scroll_up);
      else deactivate_scroll(scroll_up);

      if(scroll.bottom) activate_scroll(scroll_down);
      else deactivate_scroll(scroll_down);
    }
  }
}

function Menu(){
  const user = useUser();
  const wrapperRef = useRef<null|HTMLDivElement>(null);
  const [ listMenu ] = useState(()=>{
    return [...List.filter((item)=>{
      if(item.permission){
        return user.permissions.indexOf(item.permission) !== -1;
      }
      return true;
    }).map((item)=>{
      if(item.children){
        item.children = item.children.filter((item2)=>{
          if(item2.permission){
            return user.permissions.indexOf(item2.permission) !== -1;
          }
          return true;
        })
      }
      return item;
    })]
  });
  useClickOutside(wrapperRef, ()=> {
    if(window.innerWidth < 1100){
      let masterpage = document.getElementById("masterpage");
      if(masterpage){
        if(masterpage.classList.contains("menu-open")){
          masterpage.classList.remove("menu-open");
        }
        let elements = masterpage.getElementsByClassName("open-menu-item");
        for (let i = 0; i < elements.length; i++) {
          const element = elements[i];
          element.classList.remove("open-menu-item");
        } 
      }
    }
  })
  const [ location ] = useState(document.location);
  const renderList = useCallback((scroll_event_handler)=>{
    let selected = {
      length:0,
      index:-1
    };
    listMenu.forEach((a,i)=>{
      if((a.link || a.path) && location.pathname.indexOf(a.link ?? a.path) === 0){
        if(a.link && a.link.length > selected.length){
          selected.index = i;
        }
        if(a.path && a.path.length > selected.length){
          selected.index = i;
        }
      }
    });

    return listMenu.map((item, key)=>{
      return <MenuItem
        {...item} 
        key={key} 
        selected={key === selected.index}
        verify={verify}
        scroll_event_handler={scroll_event_handler}
        icon={<Icon name={item.icon} styleFamily="duotone" style={{"--fa-secondary-opacity":0.6}}/>}
      />;
    })
  },[location, listMenu]);

  useEffect(()=>{
    var doit: NodeJS.Timeout;
    function con(){
      clearTimeout(doit);
      doit = setTimeout(verify, 500);
    }
    verify();
    if(wrapperRef && wrapperRef.current){
      window.addEventListener('resize', con, true);
      return()=>{
        window.removeEventListener('resize', con, true);
      }
    }
  },[wrapperRef]);

  function scroll_event_handler(n:number){
    function getElement(element:Element,name:string){
      let list = element.getElementsByClassName(name);
      if(list.length > 0){
        return list[0];
      }
      return null;
    }
    const menu_list = document.getElementById("masterpage-menu-list-area");
    if(menu_list){
      const ul = getElement(menu_list,"list-item");
      if(ul){
        var a = ul.scrollTop;
        // var b = ul.scrollHeight - ul.clientHeight;
        // var c = a / b;
        
        ul.scroll({top: a+n, left: 0 })
        a = ul.scrollTop;
        // b = ul.scrollHeight - ul.clientHeight;
        // c = a / b;
        setTimeout(verify,100);
      }
    }
  }


  let interval: NodeJS.Timeout;
  function move(n:number){
    interval = setInterval(()=>{
      scroll_event_handler(n)
    },10);
  }

  function stop(){
    clearInterval(interval);
  }

  return <div id="masterpage-menu" ref={wrapperRef}>
    <div id="masterpage-menu-top-area">
      <div id="masterpage-menu-logo">
        <img alt="sim-logo-hw" src="/images/logo-sim-hw.png"></img>
      </div>
      <div className="icon-menu-open">
        <Icon name="bars" onClick={()=>openMenu()}/>
      </div>
    </div>
    <div id="masterpage-menu-list-area">
      <div className="up-scroll scroll-disabled" onMouseEnter={()=>move(-1)} onMouseLeave={()=>stop()}></div>
      <ul className="list-item">
        {renderList(scroll_event_handler)}
      </ul>
      <div className="down-scroll scroll-disabled" onMouseEnter={()=>move(1)} onMouseLeave={()=>stop()}></div>
    </div>
  </div>
}

export default Menu;